module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [_c('el-dialog', {
    attrs: {
      "title": _vm.$t('base.deleteConfirm'),
      "size": "tiny"
    },
    model: {
      value: (_vm.deleteDialog),
      callback: function($$v) {
        _vm.deleteDialog = $$v
      },
      expression: "deleteDialog"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('user.deleteConfirmText')) + " " + _vm._s(_vm.selectedUser.name))]), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.deleteDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.cancel')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.deleteSelectedUser()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('base.confirm')))])], 1)]), _vm._v(" "), _c('el-row', {
    staticStyle: {
      "padding": "10px 0px"
    },
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    staticStyle: {
      "float": "right",
      "text-align": "right"
    },
    attrs: {
      "span": 6
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.navigate({
          name: 'user.new'
        })
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('user.create')))])], 1)], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "border": "border"
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": _vm.$t('user.name'),
      "property": "name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('user.username'),
      "property": "username"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('user.email'),
      "property": "email"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": _vm.$t('user.role'),
      "property": "roles.name"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "70"
    },
    scopedSlots: _vm._u([
      ["default", function(scope) {
        return [_c('el-dropdown', {
          staticStyle: {
            "cursor": "pointer"
          },
          attrs: {
            "trigger": "click",
            "size": "small"
          }
        }, [_c('span', {
          staticClass: "el-dropdown-link"
        }, [_c('i', {
          staticClass: "el-icon-more"
        })]), _vm._v(" "), _c('el-dropdown-menu', {
          slot: "dropdown"
        }, [_c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.navigate({
                name: 'user.edit',
                params: {
                  id: _vm.users[scope.$index].id
                }
              })
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.edit')))]), _vm._v(" "), _c('el-dropdown-item', {
          attrs: {
            "size": "mini"
          },
          nativeOn: {
            "click": function($event) {
              _vm.confirmDelete(_vm.users[scope.$index])
            }
          }
        }, [_vm._v(_vm._s(_vm.$t('base.delete')))])], 1)], 1)]
      }]
    ])
  })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "10px 0px",
      "text-align": "right"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    attrs: {
      "layout": "total, sizes, prev, pager, next",
      "page-size": _vm.pageSize,
      "total": _vm.count
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handlePageChange
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-082ffb2c"}!./src/pages/user/view/index.html
// module id = 796
// module chunks = 1